@let lotteriesList = lotteries();
@let limitData = limit();
@let emptyStateData = emptyState();

<ul class="flex flex-col gap-6 ">
  @if (lotteriesList) {
    @if (lotteriesList.length === 0 && emptyStateData) {
      <homey-lottery-list-item-empty [title]="emptyStateData.title"
                                     [description]="emptyStateData.description"/>
    } @else {
      @for (lottery of lotteriesList | slice:0:limitCount(); track lottery.id) {
        <li>
          <ng-container *ngTemplateOutlet="lastLineItem(); context: { $implicit: lottery }"></ng-container>
        </li>
      }
      @if (limitData && lotteriesList.length > limitData.number && limitData.seeMoreLink) {
        <div>
          <div class="flex flex-row justify-center items-center">
            <homey-details-button [link]="limitData.seeMoreLink"/>
          </div>
          @if (limitData.seeMoreText) {
            <p class="text-surface-500 text-xs text-center">{{ limitData.seeMoreText }}</p>
          }</div>

      }
    }
  } @else {
    @for (skeleton of skeletons(); track skeleton) {
      <li>
        <homey-lottery-list-item-skeleton/>
      </li>
    }
  }
</ul>
